export var INTAKE_SITE_STAGING = 'datad0g.com';
export var INTAKE_SITE_US = 'datadoghq.com';
export var INTAKE_SITE_US3 = 'us3.datadoghq.com';
export var INTAKE_SITE_US5 = 'us5.datadoghq.com';
export var INTAKE_SITE_EU = 'datadoghq.eu';
//# sourceMappingURL=intakeSites.js.map